export default __webpack_public_path__ + "static/media/modul_sample_bg.c43634b2.png";